import Controller from "./finesReimbursements.controller";
import template from "./finesReimbursements.html";

const finesReimbursements = {
  template,
  controller: Controller,
};

export default finesReimbursements;



// WEBPACK FOOTER //
// ./src/pages/finesReimbursements/finesReimbursements.component.js